import { useState, useEffect } from "react";
import Title from "../../components/Common/Title";

function ComparePage() {
  const title = "Org Compare";
  return <Title title={title} />;
}

export default ComparePage;
